export default __webpack_public_path__ + "static/media/news13.3248c769.jpg";